import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';
import {
  buildListQuery,
  ListQueryOptions,
  normalizePaginatedListResponse,
  PaginatedApiResponse,
} from '../../../services/paginatedList';
import { moduleConfig } from './config';
import type { NoonReport } from './types';

export type NoonReportListFilters = {
  vesselId?: string;
  reportDateFrom?: string;
  reportDateTo?: string;
};

export const useNoonReports = (
  searchParams?: string,
  page = 1,
  limit = 25,
  options?: ListQueryOptions,
  filters?: NoonReportListFilters,
) => {
  const params = new URLSearchParams(buildListQuery(searchParams, page, limit, options).slice(1));
  if (filters?.vesselId) params.set('vesselId', filters.vesselId);
  if (filters?.reportDateFrom) params.set('reportDateFrom', filters.reportDateFrom);
  if (filters?.reportDateTo) params.set('reportDateTo', filters.reportDateTo);
  const q = `?${params.toString()}`;
  const { data, error, isLoading, mutate } = useSWR<
    PaginatedApiResponse<NoonReport> | NoonReport[]
  >(`${moduleConfig.module.api.list}${q}`, fetcher, { revalidateOnFocus: true });
  const normalized = normalizePaginatedListResponse<NoonReport>(data, page, limit);
  return {
    data: normalized.data,
    total: normalized.total,
    page: normalized.page,
    limit: normalized.limit,
    isLoading,
    isError: error,
    mutate,
  };
};

export const useNoonReport = (id?: number) => {
  const { data, error, isLoading, mutate } = useSWR<NoonReport>(
    id != null && Number.isFinite(id) && id > 0 ? moduleConfig.module.api.detail(id) : null,
    fetcher,
    { revalidateOnFocus: true },
  );
  return { data, item: data, isLoading, isError: error, mutate };
};

export type { NoonReport };
